import React from 'react';
import TextField from '@material-ui/core/TextField';
import Tooltip from '../Tooltip';
import useStyles from './index.style';

export default (props) => {
  const { tooltip, label, InputProps } = props;
  const classes = useStyles();
  const textlabel = tooltip ? (
    <>
      <span className={classes.labelWithTooltip}>{label}</span>
      <Tooltip title={tooltip} />
    </>
  ) : (
    label
  );

  const defaultProps = {
    ...props,
    ...{
      InputProps: {
        disableUnderline: true,
        endAdornment: InputProps ? InputProps.endAdornment : '',
      },
      InputLabelProps: { shrink: true },
      textlabel,
    },
  };

  return <TextField fullWidth {...defaultProps} className={classes.root} />;
};
